import { Dialog, Button } from "@material-ui/core";
import assert from "assert";
import { useState, FormEvent } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TerminalEditForm } from "../../components/TerminalEditForm";
import { TerminalAttachmentSection } from "../../components/TerminalAttachmentSection";
import { TerminalForm } from "../../gateways/cms/terminal";
import { useGetTerminalQuery, useCreateTerminalMutation, useUpdateTerminalMutation } from "../../gateways/cms/terminalApi";

import { styled } from "@mui/system";

type TabKey = "basic" | "attachments";

// style
const TabList = styled("ul")`
    display: flex;
    justify-content: start;
    align-items: center;
    padding: 16px 106px 0;
    border-bottom: 4px solid #3A3E5D;

    li {
        width: 160px;
        height: 36px;
        text-align: center;
        margin: 0 4px 0 0;
        border-radius: 8px 8px 0 0;
        background-color: #DADDDE;
        overflow: hidden;
        line-height: 36px;
        cursor: pointer;

        &.current {
            color: #fff;
            background-color: #3A3E5D;
        }
    }
`;
const AttachmentsMain = styled("div")`
    padding: 24px 106px 16px;
    flex: 1;
    overflow: auto;
`;
const DialogOuter = styled(Dialog)`
    .MuiDialog-paper {
        width: 800px;
        max-width: 100%;
        border-radius: 16px;
        display: flex;
        flex-direction: column;
        max-height: 90vh;

        form{
            display: flex;
            flex-direction: column;
            overflow: hidden;
        }
        main {
            display: flex;
            flex-wrap: wrap;
            padding: 40px 106px 16px;
            flex: 1;
            overflow: auto;
        }
        footer {
            padding: 0 32px;
            background-color: #f4f4f4;

            .supplement{
                padding-top: 16px;
                text-align: center;
            }
            .buttons{
                display: flex;
                justify-content: center;
                align-items: center;
                height: 64px;
            }

            button {
                height: 32px;
                width: 166px;
                border-radius: 2px;
                padding: 4px;

                &.MuiButton-contained {
                    color: #f4f4f4;
                    background-color: #3a3e5d;
                    border-color: #3a3e5d;
                }
                &.MuiButton-outlined {
                    background-color: #fff;
                    border-width: 2px;
                    border-color: #c9cbd3;
                }

                & + button {
                    margin-left: 36px;
                }
            }
        }
    }
`;

export default function TerminalEditModal() {
    const { organizationId, id } = useParams();
    assert(organizationId);
    assert(id);
    const [createFlag, setCreateFlag] = useState(false);
    const [activeTab, setActiveTab] = useState<TabKey>("basic");

    const navigate = useNavigate();
    const terminal = useGetTerminalQuery(id);
    const [terminalUpdate] = useUpdateTerminalMutation();
    const [terminalCreate] = useCreateTerminalMutation();

    const handleDismiss = (e: FormEvent) => {
        e.preventDefault();
        navigate(-1);
    };

    const handleSubmit = (data: TerminalForm) => {
        if(createFlag){
            if(data.name === terminal.data?.name){
                alert("端末名「" + data.name + "」を変更してください");
                return;
            }
            terminalCreate(data);
        }
        else{
            terminalUpdate(data);
        }
        navigate(-1);
    };

    return (
        <DialogOuter aria-labelledby="label" open onClose={handleDismiss}>
            {terminal.data && (
                <>
                    <TabList>
                        <li className={activeTab === "basic" ? "current" : ""} onClick={() => setActiveTab("basic")}>
                            基本情報
                        </li>
                        <li className={activeTab === "attachments" ? "current" : ""} onClick={() => setActiveTab("attachments")}>
                            添付資料
                        </li>
                    </TabList>

                    {activeTab === "basic" && (
                        <TerminalEditForm organizationId={organizationId} data={terminal.data} onSubmit={handleSubmit}>
                            <footer>
                                <section className="buttons">
                                    <Button type="button" variant="outlined"  onClick={handleDismiss}>
                                        キャンセル
                                    </Button>
                                    <Button type="submit" variant="contained" disableElevation >保存</Button>
                                    <Button type="submit" variant="contained" onClick={() => setCreateFlag(true)} disableElevation >
                                        新しい端末として保存
                                    </Button>
                                </section>
                            </footer>
                        </TerminalEditForm>
                    )}

                    {activeTab === "attachments" && (
                        <>
                            <AttachmentsMain>
                                <TerminalAttachmentSection terminalId={terminal.data.id} />
                            </AttachmentsMain>
                            <footer>
                                <section className="buttons">
                                    <Button type="button" variant="outlined" onClick={handleDismiss}>
                                        閉じる
                                    </Button>
                                </section>
                            </footer>
                        </>
                    )}
                </>
            )}
        </DialogOuter>
    );
}
